module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><path id=\"icon-folder@2x-a\" d=\"M10,5 L5,5 L5,5 C3.8954305,5 3,5.8954305 3,7 L3,17 L3,17 C3,18.1045695 3.8954305,19 5,19 L19,19 L19,19 C20.1045695,19 21,18.1045695 21,17 L21,9 L21,9 C21,7.8954305 20.1045695,7 19,7 L12,7 L10,5 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/folder.svg
// module id = 753
// module chunks = 0